import React from 'react';
import PageHeader from '../../components/pageHeader/PageHeader';
import Wrapper from '../../components/atoms/DirectorioWrapper';
import TabsHeader from '../../components/pageComponents/TabsHeader';
import ConvocatoriasDisponibles from './misTrasladosYPromociones/ConvocatoriasDisponibles';
import EntrevistasPorEvaluar from './misTrasladosYPromociones/EntrevistasPorEvaluar';
import ClasesModeloPorCompletar from './misTrasladosYPromociones/ClasesModeloPorCompletar';

// ──────────────────────────────────────────────────────────────────────────
// "Mis Traslados y Promociones" — bandeja del colaborador (Pieza E).
//
// Contenedor de pestañas (30/09/2026, a pedido de Jody: mismo patrón que
// /adminGestionVacaciones — TabsHeader con un componente por pestaña — para
// que la búsqueda por nombre solo aplique a "Convocatorias disponibles" y no
// se mezcle con las otras pestañas). Cada pestaña resuelve su propio
// fetch/loading (ver ConvocatoriasDisponibles.jsx, EntrevistasPorEvaluar.jsx y
// ClasesModeloPorCompletar.jsx); este componente solo arma el layout.
//
// Orden de pestañas: "Convocatorias disponibles" primero porque es el uso
// histórico/principal de esta página (antes era todo el contenido); "Entrevistas
// por completar" y "Clases modelo por completar" (28/09/2026, esta última
// todavía solo visual — ver comentario en ClasesModeloPorCompletar.jsx, Jody
// está definiendo los campos de su lista) son las incorporaciones nuevas. Si
// Jody prefiere otro orden (como en /adminGestionVacaciones, donde la lista de
// tareas pendientes va primero), es un cambio de una sola línea (reordenar el
// array de tabs).
// ──────────────────────────────────────────────────────────────────────────

const MisTrasladosYPromociones = () => {
    const tabs = [
        { id: 'tabConvocatoriasDisponibles', title: 'Convocatorias disponibles', component: <ConvocatoriasDisponibles /> },
        { id: 'tabEntrevistasPorEvaluar', title: 'Entrevistas por completar', component: <EntrevistasPorEvaluar /> },
        { id: 'tabClasesModeloPorCompletar', title: 'Clases modelo por completar', component: <ClasesModeloPorCompletar /> },
    ];

    return (
        <Wrapper className="App">
            <PageHeader title="Mis Traslados y Promociones" />
            <TabsHeader list={tabs} />
        </Wrapper>
    );
};

export default MisTrasladosYPromociones;
